/*
* layout file
* */

export const nayo_layout_1 = (resolve) => require(["./nayo-layout/nayo-layout.vue"], resolve)